import Modal from "common/Modal";
import Button from "common/commonButton";
import { useTranslation } from "react-i18next";
import { makeUserLogout } from "../../../utils";
import "./style.css";

const LogoutModal = ({
  logout_modalVisibility,
  onClose,
}: {
  logout_modalVisibility?: boolean;
  onClose?: () => void;
}) => {
  const { t } = useTranslation("sideBar");

  return (
    <Modal
      isOpen={logout_modalVisibility}
      onClose={onClose}
      modalHeading={t("logout")}
    >
      <div className="logoutModal">
        <h3 className="heading3 message">{t("are_you_sure_you...")}</h3>

        <div className="renderButtons">
          <Button
            title={t("cancel")}
            className={"cancel_button"}
            titleClassName={"title"}
            onClick={() => {
              onClose && onClose();
            }}
            variant={"primary"}
          />
          <Button
            title={t("logout")}
            className={"logout_button"}
            titleClassName={"title"}
            onClick={() => {
              makeUserLogout();
              onClose && onClose();
            }}
            variant={"primary"}
          />
        </div>
      </div>
    </Modal>
  );
};

export default LogoutModal;
